// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"59fb438f","220":"0daa5ddf","428":"81197e08","468":"30cf04e2","492":"ea028cc4","642":"fb272b72","715":"ad1877cc","820":"2d96a686","887":"4712186b","898":"c27ecd1a","983":"7276b2d8"}[chunkId] + ".chunk.js";
};